import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { CalAngularService } from "@cvx/cal-angular";
import { environment } from "@environment/environment";
import { catchError, switchMap, throwError } from "rxjs";

export const SUPPRESS_AUTH_ERROR_REDIRECT = new HttpContextToken<boolean>(() => false);

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {

    const calService = inject(CalAngularService);
    const router = inject(Router);

    if (!req.url.startsWith(environment.appApiURL)) {
        return next(req);
    }

    return calService.getAADToken([environment.clientId + "/user_impersonation"], false).pipe(
        switchMap(token => {
            const authReq = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
            return next(authReq).pipe(
                catchError((err: HttpErrorResponse) => {
                    if (!req.context.get(SUPPRESS_AUTH_ERROR_REDIRECT) &&
                        (err.status === HttpStatusCode.Unauthorized || err.status === HttpStatusCode.Forbidden)) {
                        router.navigate([`/${err.status}`]);
                    }
                    return throwError(() => err);
                })
            );
        }));
}